import { render } from "./EditFolderComponent.vue?vue&type=template&id=1b7f0a78&ts=true"
import script from "./EditFolderComponent.vue?vue&type=script&lang=ts"
export * from "./EditFolderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__